import script from "./AppSnackbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts&setup=true"

import "./AppSnackbar.vue?vue&type=style&index=0&id=c9dfad2a&lang=scss"

const __exports__ = script;

export default __exports__